import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { cn } from '@/lib/utils';

type LogoutButtonProps = {
  collapsed: boolean;
};

export const LogoutButton = ({ collapsed }: LogoutButtonProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Logged out",
        description: "You have been successfully logged out",
      });
      navigate('/admin-web/login');
    } catch (error) {
      console.error('Error logging out:', error);
      toast({
        title: "Error",
        description: "There was an error logging out",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="p-2 border-t">
      <Button
        variant="ghost"
        className={cn(
          "w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50",
          collapsed ? "px-2" : "px-4"
        )}
        onClick={handleLogout}
      >
        <LogOut className="h-5 w-5" />
        {!collapsed && <span>Logout</span>}
      </Button>
    </div>
  );
};